import { render, staticRenderFns } from "./loan-details.vue?vue&type=template&id=52f5e4bc&scoped=true&"
import script from "./loan-details.vue?vue&type=script&lang=js&"
export * from "./loan-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f5e4bc",
  null
  
)

export default component.exports